import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";

import {LoginComponent} from "./login/login.component";
import {ResetComponent} from "./reset/reset.component";
import {ResetRequestComponent} from "./reset-request/reset-request.component";
import {RegisterComponent} from "./register/register.component";

const routes: Routes = [
    {
        path: "",
        pathMatch: "full",
        redirectTo: "login"
    },
    {
        path: "signin",
        redirectTo: "login"
    },
    {
        path: "login",
        component: LoginComponent
    },
    {
        path: "register",
        component: RegisterComponent
    },
    {
        path: "reset/:token",
        pathMatch: "full",
        component: ResetComponent,
    },
    {
        path: "reset",
        component: ResetRequestComponent
    },
    {
        path: "legal",
        loadChildren: () => import("./legal/legal.module").then(m => m.LegalModule)
    },
    {
        path: "**",
        redirectTo: "/"
    }
]

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        scrollPositionRestoration: "top"
    })],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
